// eslint-disable-next-line no-shadow
export enum TEST_EXPORT_TYPES {
  CALCS,
  CALCS_WITH_COMPARISON,
  FORCE,
  VELOCITY,
  POWER,
  RSI,
  DISPLACEMENT,
  REPETITIONS,
  SENSORS,
  COP,
}
